export const lastPositionTruckImplementIconOn = {
  url: 'content/images/map-icons/icon_pin_on.png',
  scaledSize: { width: 23, height: 40 },
};

export const lastPositionTruckImplementIconOff = {
  url: 'content/images/map-icons/icon_pin_off.png',
  scaledSize: { width: 23, height: 40 },
};

export const lastPositionTruckImplementIconOutdated = {
  url: 'content/images/map-icons/icon_pin_outdated.png',
  scaledSize: { width: 23, height: 40 },
};

export const mechanicalWorkshopIcon = {
  url: 'content/images/map-icons/icon_mechanical_workshop.png',
  scaledSize: { width: 40, height: 40 },
};

export const truckImplementClusterStyle = [
  {
    url: 'content/images/map-icons/icon_dot_cluster_black.png',
    textColor: '#00EA80',
    textSize: 15,
    width: 45,
    height: 45,
  },
];

export const pointsOfInterestClusterStyle = [
  {
    url: 'content/images/map-icons/icon_dot_cluster_green.png',
    textColor: '#000814',
    textSize: 15,
    width: 51,
    height: 50,
  },
];
